var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMcFileText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0C10.7451 0 0 10.7452 0 24V176C0 189.255 10.7451 200 24 200H176C189.255 200 200 189.255 200 176V24C200 10.7452 189.255 0 176 0H24ZM129.7 62.33C128.673 62.11 127.537 62 126.29 62H74.04C72.8667 62 71.73 62.11 70.63 62.33C69.53 62.55 68.65 63.1733 67.99 64.2C67.33 65.1533 67 66.8033 67 69.15C67 71.4967 67.33 73.1833 67.99 74.21C68.65 75.1633 69.53 75.7867 70.63 76.08C71.73 76.3 72.8667 76.41 74.04 76.41H91.97V130.75C91.97 132.143 92.0801 133.5 92.3 134.82C92.52 136.067 93.2168 137.093 94.3899 137.9C95.5632 138.633 97.47 139 100.11 139C102.823 139 104.73 138.633 105.83 137.9C107.003 137.093 107.7 136.067 107.92 134.82C108.213 133.573 108.36 132.253 108.36 130.86V76.41H126.07C127.317 76.41 128.49 76.3 129.59 76.08C130.69 75.86 131.57 75.2367 132.23 74.21C132.963 73.1833 133.33 71.5333 133.33 69.26C133.33 66.84 132.963 65.1533 132.23 64.2C131.57 63.1733 130.727 62.55 129.7 62.33Z",
    fill: "#6F8BB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcFileText);
export default __webpack_public_path__ + "static/media/mc-file-text.3fa5c48447616777145c5200bbd23cd7.svg";
export { ForwardRef as ReactComponent };